<div class="flex items-center gap-6 h-full">
  <a routerLink="/" class="flex-none">
    <div class="hidden sm:contents">
      <img class="h-8 block dark:hidden" src="/assets/logo-easihub-light.png" alt="EASiHub" loading="eager" />
      <img class="h-8 hidden dark:block" src="/assets/logo-easihub-dark.png" alt="EASiHub" loading="eager" />
    </div>
    <img class="h-8 max-sm:block hidden" src="/assets/logo-easihub-symbol.png" alt="EASiHub" loading="eager" />
  </a>

  <nav class="hidden 2xl:flex items-center gap-5">
    @for (link of navLinks; track link.label) {
    <a [routerLink]="link.path" class="text-sm font-medium text-on-surface-variant hover:text-primary no-underline">
      {{ link.label }}
    </a>
    }
  </nav>

  <div class="ml-auto flex items-center gap-2.5">
    <button color-scheme-toggle></button>

    <account-widget></account-widget>
    <button class="btn btn-flat btn-shadow btn-secondary">Ask a Question</button>
  </div>
</div>